module.exports = __webpack_public_path__ + "img/circle-info.a7d1e4.svg";